import { Head } from '@inertiajs/react'
import { useState } from 'react'
import { Button } from "@/components/ui/button"

// import cs from './InertiaExample.module.css'

import { AppSidebar } from "@/components/app-sidebar"
import { SiteHeader } from "@/components/site-header"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"


export default function Layout({ children }: { children: React.ReactNode }) {
  useFlash()
  
  return (
    <>
      <SidebarProvider>
        <Toaster richColors />
        <AppSidebar variant="inset" />
        <SidebarInset>
          <SiteHeader />
          <div className="flex flex-1 flex-col">
            <div className="@container/main flex flex-1 flex-col gap-2">
              <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
                {children}
              </div>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </>
  )
}
